import { render, staticRenderFns } from "./FeedCreate.vue?vue&type=template&id=37ce3aec&scoped=true"
import script from "./FeedCreate.vue?vue&type=script&lang=js"
export * from "./FeedCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ce3aec",
  null
  
)

export default component.exports